export const LinedataLeave = (canvas) => {
  const ctx = canvas.getContext('2d')
  const gradient1 = ctx.createLinearGradient(10, 10, 255, 1)
  gradient1.addColorStop(0, ' lightblue')
  gradient1.addColorStop(1, '#F5F8FF')
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    datasets: [
      {
        label: 'My First Dataset',
        data: [4, 7, 6, 8, 11, 5, 3, 4, 7, 9, 10, 9, 8],
        pointBackgroundColor: 'rgba(51, 73, 159, 1)',
        pointBorderColor: '#fff',
        borderColor: 'rgba(51, 73, 159, 0.8)',
        backgroundColor: 'rgba(51, 73, 159, 0.1)',
        tension: 0,
        fill: true,
      },
    ],
  }
}
export const LinedataLeaveoptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          drawOnChartArea: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Months',
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          drawOnChartArea: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'No. of leaves',
        },
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 20,
          stepSize: 1,
        },
      },
    ],
  },
}

export default { LinedataLeave, LinedataLeaveoptions }
